import { createAsyncThunk } from '@reduxjs/toolkit';
import { saveMetadata } from './metadata.action';

export const setListStyle = createAsyncThunk('text/set_ordered_list_style', async (payload, { dispatch }) => {
  await dispatch(saveMetadata(payload));
  INKIVE.Metadata.bullet_and_ordered_list = payload.bullet_and_ordered_list;

  return payload;
});
